import React from 'react'
import { useParams } from 'react-router-dom'
import TaskForm from './TaskForm'

const TaskEdit = () => {
  const { id } = useParams()

  return (
    <TaskForm 
      mode="edit" 
      taskId={id}
    />
  )
}

export default TaskEdit

